import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/shape-2.png'


const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "card border-0 p-4 bg-white rounded-3 mb-4 position-relative" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-4 col-sm-6 pe-4" }
const _hoisted_7 = { class: "col-md-4 col-sm-6 border-start ps-lg-4" }
const _hoisted_8 = { class: "col-lg-4" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-7" }
const _hoisted_11 = { class: "col-lg-5" }
const _hoisted_12 = { class: "row justify-content-center" }
const _hoisted_13 = { class: "col-md-6 col-xl-4" }
const _hoisted_14 = { class: "col-md-6 col-xl-4" }
const _hoisted_15 = { class: "col-md-6 col-xl-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-lg-5" }
const _hoisted_18 = { class: "col-lg-7" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-lg-7" }
const _hoisted_21 = { class: "col-lg-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnalyticsOverviewChart = _resolveComponent("AnalyticsOverviewChart")!
  const _component_WebsiteVisitsChart = _resolveComponent("WebsiteVisitsChart")!
  const _component_NewRegistersChart = _resolveComponent("NewRegistersChart")!
  const _component_RealtimeActiveUsersChart = _resolveComponent("RealtimeActiveUsersChart")!
  const _component_BrowserUsedByUsers = _resolveComponent("BrowserUsedByUsers")!
  const _component_BrowserUsedByUsersChart = _resolveComponent("BrowserUsedByUsersChart")!
  const _component_ClicksChart = _resolveComponent("ClicksChart")!
  const _component_ImpressionsChart = _resolveComponent("ImpressionsChart")!
  const _component_SessionsChart = _resolveComponent("SessionsChart")!
  const _component_SessionsByChannelChart = _resolveComponent("SessionsByChannelChart")!
  const _component_ClicksImpressionsByKeywords = _resolveComponent("ClicksImpressionsByKeywords")!
  const _component_TopBrowsingPagesToday = _resolveComponent("TopBrowsingPagesToday")!
  const _component_UsersByCountry = _resolveComponent("UsersByCountry")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AnalyticsOverviewChart),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_WebsiteVisitsChart)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_NewRegistersChart)
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-3 d-none d-md-block" }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "position-absolute top-0 end-0 bottom-0 shape-2",
                alt: "shape"
              })
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_RealtimeActiveUsersChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_BrowserUsedByUsers)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_BrowserUsedByUsersChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_ClicksChart)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_ImpressionsChart)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_SessionsChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_SessionsByChannelChart)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_ClicksImpressionsByKeywords)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_TopBrowsingPagesToday)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_UsersByCountry)
      ])
    ])
  ]))
}